// extracted by mini-css-extract-plugin
export default {"StatsTab":"StatsTab_StatsTab__8KYNg","shadow":"StatsTab_shadow__xyB5P","title":"StatsTab_title__dOOq0","stat":"StatsTab_stat__lxEQD","gradient":"StatsTab_gradient__u+rpv"};